/**
 *  This file was to define all public and internal events
 */
/** @hidden */
export var load = 'load';
/** @hidden */
export var rowDataBound = 'rowDataBound';
/** @hidden */
export var queryCellInfo = 'queryCellInfo';
/** @hidden */
export var toolbarClick = 'toolbarClick';
/** @hidden */
export var keyPressed = 'key-pressed';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-gantt/src/gantt/base/constant.js
// module id = null
// module chunks = 